import {
  DOWNLOAD_PRODUCT_PDF,
  DOWNLOAD_PRODUCT_PDF_FULFILLED,
  DOWNLOAD_PRODUCT_PDF_REJECTED,
  PRINT_PRODUCT_PDF,
  PRINT_PRODUCT_PDF_FULFILLED,
  PRINT_PRODUCT_PDF_REJECTED,
} from 'b2b-apps/shop/product/redux/productPdf/actionTypes';
import {
  DownloadProductPdfAction,
  DownloadProductPdfActionFulfilled,
  DownloadProductPdfActionRejected,
  PrintProductPdfAction,
  PrintProductPdfActionFulfilled,
  PrintProductPdfActionRejected,
} from 'b2b-apps/shop/product/redux/productPdf/types';

const downloadProductPdf = (
  sku: string,
  content: string,
): DownloadProductPdfAction => ({
  type: DOWNLOAD_PRODUCT_PDF,
  payload: {
    content,
    sku,
  },
});

const downloadProductPdfFulfilled = (): DownloadProductPdfActionFulfilled => ({
  type: DOWNLOAD_PRODUCT_PDF_FULFILLED,
});

const downloadProductPdfRejected = (
  error: ErrorType,
): DownloadProductPdfActionRejected => ({
  type: DOWNLOAD_PRODUCT_PDF_REJECTED,
  payload: {
    error,
  },
});

const printProductPdf = (
  sku: string,
  content: string,
): PrintProductPdfAction => ({
  type: PRINT_PRODUCT_PDF,
  payload: {
    content,
    sku,
  },
});

const printProductPdfFulfilled = (): PrintProductPdfActionFulfilled => ({
  type: PRINT_PRODUCT_PDF_FULFILLED,
});

const printProductPdfRejected = (
  error: ErrorType,
): PrintProductPdfActionRejected => ({
  type: PRINT_PRODUCT_PDF_REJECTED,
  payload: {
    error,
  },
});

export {
  downloadProductPdf,
  downloadProductPdfFulfilled,
  downloadProductPdfRejected,
  printProductPdf,
  printProductPdfFulfilled,
  printProductPdfRejected,
};
